import { Navigate, Route, Routes } from 'react-router-dom';
import { PublicShell } from '@/components/PublicShell';
import { demosPagePath } from '@/content/site';
import { DemosPage } from '@/pages/DemosPage';
import { LandingPage } from '@/pages/LandingPage';
import { MobileLandingPage } from '@/pages/MobileLandingPage';
import { ReschedulePage } from '@/pages/ReschedulePage';
import { AdminLoginPage } from '@/pages/admin/AdminLoginPage';
import { AdminStatsPage } from '@/pages/admin/AdminStatsPage';
import { isMobileLanding } from '@/lib/isMobileLanding';

export default function App() {
  const home = isMobileLanding() ? <MobileLandingPage /> : <LandingPage />;

  return (
    <PublicShell>
      <Routes>
        <Route path="/" element={home} />
        <Route path={demosPagePath} element={<DemosPage />} />
        <Route path="/reagendar/:token" element={<ReschedulePage />} />
        <Route path="/admin" element={<Navigate to="/admin/stats" replace />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin/stats" element={<AdminStatsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </PublicShell>
  );
}
